<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M205 1095 c-23 -9 -57 -29 -78 -46 -42 -34 -92 -113 -82 -129 11 -18
42 -11 53 14 20 44 73 95 118 112 80 30 192 1 252 -68 47 -53 120 -72 177 -46
15 7 24 18 23 27 -3 13 -16 15 -63 13 -57 -3 -59 -2 -40 14 38 31 140 74 176
74 46 0 96 -17 134 -45 37 -28 81 -106 90 -162 l6 -41 -43 -7 c-179 -27 -289
-145 -289 -309 0 -72 14 -123 52 -179 30 -45 30 -48 15 -72 -17 -26 -40 -31
-65 -16 -7 5 -27 75 -46 161 -18 88 -38 156 -46 161 -20 13 -55 11 -66 -3 -6
-7 -25 -78 -42 -158 -18 -80 -38 -151 -46 -159 -8 -8 -23 -11 -37 -8 -18 5
-42 44 -111 179 -109 216 -164 319 -174 329 -5 5 -15 4 -23 -1 -20 -12 -3 -59
65 -175 28 -49 81 -150 116 -223 48 -101 70 -137 91 -148 39 -20 73 -17 104 9
23 20 31 44 59 173 19 91 34 141 38 129 3 -11 18 -76 32 -145 22 -110 29 -128
55 -152 43 -39 84 -37 124 5 l31 33 47 -24 c147 -76 340 -8 415 146 23 46 28
70 28 132 0 65 -4 84 -33 143 -37 74 -91 123 -168 153 -43 16 -44 18 -44 63
-1 87 -67 187 -155 234 -30 16 -58 21 -110 22 -64 0 -77 -4 -148 -43 l-78 -43
-37 20 c-119 67 -201 84 -277 56z m867 -372 c159 -87 185 -303 50 -425 -57
-52 -118 -72 -197 -66 -140 12 -238 119 -238 263 -1 198 210 323 385 228z"
      />
      <path
        d="M882 648 c-7 -7 -12 -25 -12 -40 0 -22 -4 -28 -23 -28 -12 0 -33 -7
-45 -16 -18 -12 -22 -25 -22 -69 0 -62 16 -85 61 -85 25 0 29 -4 29 -28 0 -40
28 -62 78 -62 49 0 82 26 82 65 0 21 5 25 29 25 38 0 61 32 61 83 0 43 -35 87
-70 87 -15 0 -20 6 -20 24 0 39 -25 56 -84 56 -28 0 -57 -5 -64 -12z m100 -75
c3 -36 5 -38 43 -43 36 -5 40 -8 43 -37 3 -31 2 -32 -40 -35 -43 -3 -43 -3
-46 -45 -3 -42 -4 -43 -37 -43 -33 0 -34 1 -37 43 -3 41 -4 42 -40 45 -36 3
-38 5 -38 38 0 33 1 34 40 34 l40 0 0 40 c0 39 1 40 34 40 33 0 35 -2 38 -37z"
      />
      <path
        d="M25 830 c-4 -7 -3 -16 3 -22 14 -14 45 -2 40 15 -6 16 -34 21 -43 7z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
